// Centralized color palette for the application
const colors = {
  primary: '#198754', // main green
  primaryDark: '#146c43',
  primaryLight: '#66bb6a',
  link: '#1aa361',
  bootstrapPrimaryVar: '--bs-primary'
};

export default colors;
